import { useQuery as useUrqlQuery } from 'urql';
import { SearchModalsContentQuery } from './searchModalsContentQuery';

export const useSearchModalsContentQuery = () => {
  const [urqlResult] = useUrqlQuery({
    query: SearchModalsContentQuery,
  });

  return urqlResult;
};
